export default function CloseIcon({color,size}) {
  return (
    <svg
      width={"14"}
      height={"13"}
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `scale(${size || 1})` }}
    >
      <g clip-path="url(#clip0_52_77)">
        <path
          d="M10.741 12.61L6.99998 8.86998L3.25798 12.61C3.00997 12.8576 2.67386 12.9966 2.32342 12.9967C1.97298 12.9967 1.63684 12.8577 1.38878 12.6102C1.14072 12.3626 1.001 12.0268 1.00029 11.6764C0.999573 11.3259 1.13793 10.9895 1.38498 10.741L5.12798 6.99998L1.38498 3.25798C1.13661 3.00961 0.99707 2.67274 0.99707 2.32148C0.99707 1.97023 1.13661 1.63336 1.38498 1.38498C1.63336 1.13661 1.97023 0.99707 2.32148 0.99707C2.67274 0.99707 3.00961 1.13661 3.25798 1.38498L6.99998 5.12698L10.741 1.38498C10.864 1.262 11.01 1.16444 11.1707 1.09789C11.3313 1.03133 11.5036 0.99707 11.6775 0.99707C11.8514 0.99707 12.0236 1.03133 12.1843 1.09789C12.345 1.16444 12.491 1.262 12.614 1.38498C12.737 1.50796 12.8345 1.65397 12.9011 1.81465C12.9676 1.97534 13.0019 2.14756 13.0019 2.32148C13.0019 2.49541 12.9676 2.66763 12.9011 2.82831C12.8345 2.989 12.737 3.135 12.614 3.25798L8.87198 6.99998L12.614 10.741C12.861 10.9895 12.9994 11.3259 12.9987 11.6764C12.998 12.0268 12.8582 12.3626 12.6102 12.6102C12.3621 12.8577 12.026 12.9967 11.6755 12.9967C11.3251 12.9966 10.989 12.8576 10.741 12.61Z"
          fill={color||"#525863"}
        />
      </g>
      <defs>
        <clipPath id="clip0_52_77">
          <rect width="14" height="13" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
